import { useRouteMatch } from 'react-router';

const toIntOrNull = ( value?: string ) => ( value ? parseInt( value, 10 ) : null );

type ProjectMatchParams = { projectID: string; }
type FolderMatchParams = { folderID: string; }

const useOrganizerFromPath = () => {
	// useParams is a simpler alternative but it returns
	// an empty object because the project tree is rendered
	// outside the <Switch/> with the routes.
	const projectMatch = useRouteMatch<ProjectMatchParams>( '/projects/:projectID' );
	const folderMatch = useRouteMatch<FolderMatchParams>( '/projects/:projectID/folders/:folderID' );

	const projectID = toIntOrNull( projectMatch?.params?.projectID );
	const folderID = toIntOrNull( folderMatch?.params?.folderID );

	if ( !projectID ) return undefined;

	return { projectID, folderID };
}

export default useOrganizerFromPath;
